module.exports = __webpack_public_path__ + "static/media/patrol(33).2afb6da9.PNG";